<template>
    <Vue100vh class="kraemmer">
        <CircleWrap @click.native="goBack" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="top">
            <div class="shadow"></div>
            <div class="stripes"></div>
        </div>
        <div class="content-wrap">
            <div class="intro">
                <div class="inner-intro">
                    <p>{{kraemmerName}}</p>
                    <button v-if="state === 'watch'" @click="state = 'select'">Opret samlet bud med flere varer</button>
                    <div v-if="state === 'select'" class="form-wrap">
                        <div class="name">1. Vælg varer</div>
                        <button class="green" @click="goToOfferScreen">2. Afgiv bud</button>
                    </div>
                    <div v-if="state === 'bid'" class="offer">
                        <template v-if="isCreatingChat">
                            <p>Sender bud til kræmmer...</p>
                        </template>
                        <template v-else>
                            <p>Du har samlet set valgt varer for {{total}} kr.</p>
                            <p class="fwn mb30">Skriv dit bud og tryk send.</p>
                            <div class="form-wrap">
                                <input type="tel" v-model="bid" placeholder="F.eks. 123 kr." :class="{'has-value': bid.length > 0}" />
                                <div v-if="bid.length > 0" class="currency">kr.</div>
                                <button class="green" :class="{'disabled': bid.length === 0}" @click="sendOffer">Send bud</button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
	        <Loader v-if="isSearching"/>
	        <template v-else>
		        <ProductsList v-model="selectedProducts" :select-mode="state === 'select' || state === 'bid'" :list-products="shownProducts"  />
		        <Loader class="search-loader" v-if="nextSearchPage !== false" ref="searchLoader"/>
	        </template>
        </div>
    </Vue100vh>
</template>

<script>
	import productHelpers from "@/mixins/productHelpers";
	import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
	import ProductsList from "@/components/products/ProductsList";
	import {mapState} from "vuex";
	import Loader from "@/components/Loader";
	import gsap from 'gsap'
	import Vue100vh from 'vue-div-100vh'
	import {isInViewport} from "@/helperFunctions";
	export default {
        mixins: [productHelpers],
		data(){
			return{
				isSearching: true,
				isCreatingChat: false,
				state: 'watch',
                bid: '',
                selectedProducts: [],
				kraemmerProducts: [],
				nextSearchPage: false,
				isLoadingMore: false
			}
		},
        created(){
	        setTimeout(function(){
		        gsap.to('.content-wrap', {
			        duration: 0.3,
			        y: 0,
			        opacity: 1,
			        ease: 'power1.easeOut'
		        })
	        }, 100)
        },
		methods: {
            goBack(){
				if(this.state === 'bid'){
					this.state = 'select'
                }else if(this.state === 'select'){
					this.state = 'watch'
                }else if(this.state === 'watch'){
					this.$router.go(-1)
                }
            },
			goToOfferScreen(){
            	if(this.selectedProducts.length > 0)
	            {
	                this.state = 'bid';
	            }
            	else
	            {
		            this.$store.dispatch('vorbasse/showPrompt',{
			            title: 'Samtale kunne ikke startes',
			            prompt: 'Du skal vælge mindst ét produkt for at åbne et tilbud.',
			            confirmText: 'Ok - forstået',
			            showCancelButton: false
		            });
	            }
			},
			performSearch(){
				const that = this;
				that.isSearching = false;
				that.kraemmerProducts = ['a','b','c','d'];
				return;
				that.$store.dispatch('vorbasse/searchForProducts',{users: that.$route.params.id})
				.then(response => {
					that.isSearching = false;
					that.kraemmerProducts = response.hits.map((value) => {return value.id});
					that.nextSearchPage = response.meta.next_page;
					const interval = setInterval(() => {
						if(typeof that.$refs['searchLoader'] !== 'undefined')
						{
							clearInterval(interval);
							if(isInViewport(that.$refs['searchLoader'].$el))
							{
								that.loadMore();
							}
						}
						
					},100)
				})
			},
			loadMore(){
				if(this.isLoadingMore === false)
				{
					const that = this;
					that.isLoadingMore = true;
					that.$store.dispatch('vorbasse/searchForProducts',{users: that.$route.params.id,after:that.nextSearchPage})
					.then(response => {
						that.isLoadingMore = false;
						const products = response.hits.map((value) => {return value.id});
						that.kraemmerProducts = that.kraemmerProducts.concat(products)
						that.nextSearchPage = response.meta.next_page;
					})
				}
			},
			checkLoadMore(){
				if(this.nextSearchPage !== false && this.isLoadingMore === false && typeof this.$refs['searchLoader'] !== 'undefined')
				{
					if(isInViewport(this.$refs['searchLoader'].$el))
					{
						this.loadMore();
					}
				}
			},
			buildOfferMessage(){
            	let offerString = 'Hej '+this.kraemmerName+'\n' +
		            'Jeg vil gerne købe de følgende varer for '+this.bid+' kr.:';

            	this.selectedProducts.forEach((productId,index) => {
            		offerString += '\n'+(index+1)+': '+this.products[productId].title;
	            })

				return offerString;
			},
			sendOffer(){
				if(!this.isCreatingChat && this.bid !== '')
				{
					this.isCreatingChat = true;
					const that = this;
					const key = this.$vorbasseSocket.onCommand('room-created', (result) =>
					{
						that.isCreatingChat = false;
						that.$vorbasseSocket.dropCommandListener('room-created', key);
						if(typeof result.result !== 'undefined' && result.result === 200)
						{
							that.$vorbasseSocket.emit('chat-message',{
								room:result.data.room,
								message: that.buildOfferMessage()
							});
							that.$vorbasseSocket.emit('open-room',result.data.room);
						}
						else
						{
							that.$store.dispatch('vorbasse/showPrompt',{
								title: 'Samtale kunne ikke startes',
								prompt: 'Samtalen kunne ikke startes. Prøv igen eller kontakt en medarbejder',
								confirmText: 'Ok - forstået',
								showCancelButton: false
							});
						}
					});

					this.$vorbasseSocket.emit('create-room', {
						type: 'kraemmerSale',
						kraemmer: this.kraemmerId,
						products: this.selectedProducts,
						returnRoom: true
					})
				}
			},
		},
		
		watch: {
			total: function(newValue){
				if(this.state === 'bid' && Math.round(Number(newValue.replace(",","."))) === 0 ){
					this.state = 'select'
                }
            }
        },
        computed: {
	        ...mapState('vorbasse', {
		        products: 'products',
		        kraemmerData: 'kraemmerData'
	        }),
	        kraemmerId(){
	            return Number(this.$route.params.id);
	        },
	        kraemmerName(){
	            return typeof this.kraemmerData[this.kraemmerId] !== 'undefined' ? this.kraemmerData[this.kraemmerId].displayName : '' ;
	        },
			shownProducts(){
				if(this.state === 'bid'){
					return this.kraemmerProducts.filter(product => this.selectedProducts.indexOf(product) !== -1)
                }
				return this.kraemmerProducts
            },
			total(){
				let total = 0;
				for(let i=0; i < this.selectedProducts.length; i++){
                    total += Number(this.products[this.selectedProducts[i]].price)
                }
				return this.getPrice(total);
            }
        },
		beforeDestroy() {
			document.getElementById('bodernePage').removeEventListener('scroll', this.checkLoadMore);
		},
		mounted()
		{
			this.$store.dispatch('vorbasse/ensureKraemmerdata',this.kraemmerId);
			this.performSearch();
			document.getElementById('bodernePage').addEventListener('scroll', this.checkLoadMore);
		},
		components: {
			Loader,
			ProductsList,
			CircleWrap,
            BackIconThin,
			Vue100vh
        }
	}
</script>

<style lang="scss" scoped>
    .kraemmer{
        background: $sky;
        position: fixed;
        width: 100vw;
        top: 0; left: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .circle{
            background: $white;
            position: fixed;
            top: 15px;
            left: 15px;
            z-index: 3;
            svg{
                transform: translate(-70%, -50%);
            }
        }
        .top{
            transform: rotate(7deg) translateY(0%);
            opacity: 1;
            @media(min-width: 992px){
                transform: rotate(5deg) translateY(0%);
            }
            @media(min-width: 1200px){
                transform: rotate(3deg) translateY(0%);
            }
            @media(min-width: 1450px){
                transform: rotate(2deg) translateY(0%);
            }
            .stripes{
                background-color: $white;
                background-image: linear-gradient(90deg, transparent 50%, #C76875 50%);
            }
        }
    }
    .intro{
        padding: 100px 15px 30px;
        position: sticky;
        top: -30px;
        z-index: 1;
        background: -moz-linear-gradient(top,  rgba(190,213,221,1) 0%, rgba(190,213,221,1) 50%, rgba(190,213,221,0) 100%);
        background: -webkit-linear-gradient(top,  rgba(190,213,221,1) 0%,rgba(190,213,221,1) 50%,rgba(190,213,221,0) 100%);
        background: linear-gradient(to bottom,  rgba(190,213,221,1) 0%,rgba(190,213,221,1) 50%,rgba(190,213,221,0) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#bed5dd', endColorstr='#00bed5dd',GradientType=0 );
        width: 100%;
        display: block;
        .inner-intro{
            max-width: 500px;
            margin: 0px auto;
        }
        p{
            display: block;
            color: $darkblue;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }
        .offer{
            p{
                font-size: 14px;
                &.fwn{
                    font-weight: normal;
                }
            }
            input{
                border: 2px solid $green;
                background: $lightblue;
                text-align: right;
                padding-right: 125px;
                color: $darkblue;
                font-weight: bold;
                &::placeholder{
                    color: $darkblue;
                    font-weight: normal;
                }
                &.has-value{
                    padding-right: 150px;
                }
            }
            .currency{
                position: absolute;
                top: 15px;
                right: 125px;
                font-size: 16px;
                color: $darkblue;
                font-weight: bold;
            }
        }
        button{
            color: $white;
            background: $green;
            text-transform: none;
            border: 2px solid $green;
        }
    }
</style>
